import React from 'react'
import { Heading, Text, Disclosure as ParoDisclosure } from 'base-ui'
import Highlighter from './Highlight'
import { PageWrapper } from './PageWrapper'
import { Disclosure as DisclosureExample } from '../examples/Disclosure'

const Disclosure = () => {
  return (
    <PageWrapper title='Disclosure' isResponsive={true}>
      <Text size='md'>Disclosure component</Text>
      <Heading size='h3'>Usage</Heading>
      <ParoDisclosure
        items={[{ title: 'test', content: 'hello world' }]}
        maxWidth='max-w-none'
      />
      <div className='py-4'>
        <Highlighter code={DisclosureExample} language='jsx' />
      </div>
    </PageWrapper>
  )
}

export default Disclosure
